import { AddonTask } from "@coworker/types/lib/tasks/addon";
import React from "react";
import { joinLocation } from "../../services/locations.service";
import { useAllSalesLocationsForArticleQuery } from "./useAllSalesLocationsForArticleQuery";

const foodHFBs = ["60", "61"];
const isSFM = (panumber: string) =>
  foodHFBs.includes((panumber || "").slice(0, 2));

function makePickupFields(storeLocation: string, locationDescription: string) {
  return {
    pickup_location: joinLocation(storeLocation, locationDescription),
    pickup_location_grid_code: storeLocation,
    pickup_location_department: locationDescription,
    pickup_location_custom: "",
  };
}

export function useTaskFormDefaultPickupFields(task: AddonTask) {
  const short_id = task?.product_article_id;
  const type = task?.product_article_type;
  const panumber = task?.panumber as string;

  const { data: locationsData, isLoading } =
    useAllSalesLocationsForArticleQuery(
      !!short_id && !!type ? `${type}${short_id}` : ""
    );

  return React.useMemo(() => {
    if (!short_id) return null;

    if (!isLoading && locationsData) {
      if (isSFM(panumber)) {
        return makePickupFields("SFM", "Swedish Food Market");
      }

      let homeLoc = null;
      if (locationsData) {
        for (const loc of locationsData) {
          if (loc?.isHome || loc?.isHomeBase) homeLoc = loc;
        }
      }
      if (!homeLoc) return null;
      return makePickupFields(
        homeLoc.storeLocation || homeLoc.location,
        homeLoc.locationDescription || homeLoc.descriptive
      );
    }
    return null;
  }, [locationsData, panumber, short_id, isLoading]);
}
